module.exports = __webpack_public_path__ + "img/ektract.7041d823.png";